import axios from 'axios';
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import * as Yup from "yup";
import Cookies from "js-cookie";
import { adminMainUrl } from '../../../Config';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { getOrganisationAgentList } from '../../../Redux/action/Organisation/OrganisationListAction';
import { customStyles } from '../../../HelperFunctions';


const OrganisationAdd = ({ accessedPermission }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;


    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(location.search);
        return urlParams.get(param);
    };




    const token = Cookies.get('token');
    const user_id = Cookies.get('flexichain_user_id');

    useEffect(() => {
        if (token && user_id) {
            dispatch(getOrganisationAgentList(token, user_id));
        } else {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        }
    }, [token]);
    const [agentOptions, setAgentOptions] = useState([]);

    const {
        loadingOrganisationAgentList,
        OrganisationAgentList,
        OrganisationAgentListError,
    } = useSelector(state => state.OrganisationListReducer);


    useEffect(() => {
        if (OrganisationAgentList) {
            let arr = [];
            OrganisationAgentList.map(v => { arr.push({ value: v.id, label: `${v.name} (${v.customerType})` }) });
            setAgentOptions(arr);
        } else {
            setAgentOptions([]);
        }
    }, [OrganisationAgentList]);



    const initialValues = {
        has_sub_agent: false,
        sub_agent_id: 0,
        customerType: "Individual/Proprietary firm",
        name: "",
        alias: "",
        email: "",
        mobile: "",
        // gst_number: "",
        // service_type : "",
        entity_type: []
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object({
            // name: Yup.string().required("Please enter name")
        }),
        onSubmit: (values) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    }
                }
                axios.post(`${adminMainUrl}/api/organization/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            navigate(`/flexichain/organization/edit/${btoa(response.data.data.id)}`)
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            formik.setFieldValue("entity_type", [...formik.values.entity_type, value]);
        } else {
            formik.setFieldValue(
                "entity_type",
                formik.values.entity_type.filter((item) => item !== value)
            );
        }
    };


    const [disbaleAgent, setDisableAgent] = useState(false);
    useEffect(() => {
        if (formik.values.has_sub_agent == true) {
            setDisableAgent(true);
            if (formik.values.entity_type.includes("agent")) {
                const updatedEntityType = formik.values.entity_type.filter((item) => item !== "agent");
                formik.setFieldValue("entity_type", updatedEntityType);
            }
        } else {
            setDisableAgent(false);
        }
    }, [formik.values.has_sub_agent]);

    const sub_agent_id_val = getQueryParam('sa'); // Get the value of 'sa' parameter
    const [disablesubagentCheckbox, setDisablesubagentCheckbox] = useState(false);
    const [disablesubagentDropdown, setDisablesubagentDropdown] = useState(false);

    useEffect(() => {
        if (sub_agent_id_val) {
            setDisablesubagentCheckbox(true);
            formik.setFieldValue("has_sub_agent", true);
            let decreptedAgentID = atob(sub_agent_id_val);
            if (decreptedAgentID) {
                let findAgentIDinagentOptions = agentOptions.find(v => v.value == atob(sub_agent_id_val));
                // console.log(findAgentIDinagentOptions);
                if (findAgentIDinagentOptions) {
                    setDisablesubagentDropdown(true);
                    formik.setFieldValue("sub_agent_id", decreptedAgentID)
                } else {
                    setDisablesubagentDropdown(false);
                    formik.setFieldValue("sub_agent_id", 0)
                }
            } else {
                setDisablesubagentDropdown(false);
                formik.setFieldValue("sub_agent_id", 0)
            }
        } else {
            formik.setFieldValue("has_sub_agent", false);
            setDisablesubagentCheckbox(false);
            setDisablesubagentDropdown(false);
            formik.setFieldValue("sub_agent_id", 0)
        }
    }, [sub_agent_id_val, agentOptions])


    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <h3>Add Organisation</h3>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            {/* Filter */}
                            <form onSubmit={formik.handleSubmit} >
                                <div className="row">
                                    <div className="col-md-6">

                                        <input
                                            type="checkbox"
                                            className='me-2'
                                            name="has_sub_agent"
                                            id="has_sub_agent"
                                            onChange={(e) => {
                                                formik.setFieldValue("has_sub_agent", e.target.checked);
                                                formik.setFieldValue("sub_agent_id", 0);
                                            }}
                                            checked={formik.values.has_sub_agent}
                                            disabled={disablesubagentCheckbox}
                                        />
                                        <label htmlFor="" className='form-label mb-0'>
                                            Sub Agent
                                        </label>
                                    </div>

                                    {formik.values.has_sub_agent && <div className="col-md-6">
                                        <label htmlFor="name" className='form-label mb-0'>
                                            Sub Agent:
                                        </label>
                                        <div className=" mb-3 mb-sm-0">
                                            <Select
                                                className='custom-selector'
                                                options={agentOptions}
                                                styles={customStyles}
                                                name="sub_agent_id"
                                                onChange={option => {
                                                    formik.setFieldValue('sub_agent_id', option.value);
                                                }}
                                                value={formik.values.sub_agent_id ? agentOptions.find(option => option.value == formik.values.sub_agent_id || null) : null}
                                                isLoading={loadingOrganisationAgentList}
                                                isDisabled={disablesubagentDropdown}
                                            />
                                        </div>
                                    </div>}
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="" className='form-label mb-0'>
                                            Type of Organisation
                                        </label>
                                        <select id="" className="form-control form-control-sm"
                                            name='customerType'
                                            value={formik.values.customerType}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}>
                                            <option value="">Select an option</option>
                                            <option value="Individual/Proprietary firm">Individual/Proprietary firm</option>
                                            <option value="Private or Public Limited Company">Private or Public Limited Company</option>
                                            <option value="Partnership firm">Partnership firm</option>
                                        </select>
                                    </div>

                                    <div className="col-md-3">
                                        <label htmlFor="name" className='form-label mb-0'>
                                            Name
                                        </label>
                                        <div className=" mb-3 mb-sm-0">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="name"
                                                name='name'
                                                value={formik.values.name}
                                                onChange={(e) => {
                                                    const uppercasedValue = e.target.value.toUpperCase();
                                                    formik.setFieldValue('name', uppercasedValue);
                                                }}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="alias" className='form-label  mb-0'>
                                            Alias
                                        </label>
                                        <div className=" mb-3 mb-sm-0">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id='alias'
                                                name='alias'
                                                value={formik.values.alias}
                                                 onChange={(e) => {
                                                    const uppercasedValue = e.target.value.toUpperCase();
                                                    formik.setFieldValue('alias', uppercasedValue);
                                                }}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="email" className='form-label  mb-0'>
                                            Email
                                        </label>
                                        <div className=" mb-3 mb-sm-0">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id='email'
                                                name='email'
                                                value={formik.values.email}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="" className='form-label  mb-0'>
                                            Mobile
                                        </label>
                                        <div className=" mb-3 mb-sm-0">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name='mobile'
                                                value={formik.values.mobile}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                onInput={(event) => {
                                                    let value = event.target.value;
                                                    value = value.replace(/[^0-9]/g, '');
                                                    event.target.value = value;
                                                }}
                                                maxLength={10}
                                            />
                                        </div>
                                    </div>
                                    {/* <div className="col-md-6">
                                        <label htmlFor="" className='form-label  mb-0'>
                                            GST Number
                                        </label>
                                        <div className=" mb-3 mb-sm-0">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name='gst_number'
                                                value={formik.values.gst_number}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            />
                                        </div>
                                    </div> */}
                                    {/* <div className="col-md-6">
                                        <label htmlFor="" className='form-label  mb-0'>
                                            Service Type
                                        </label>
                                        <div className=" mb-3 mb-sm-0">
                                            <select
                                                className="form-control form-control-sm"
                                                name='service_type'
                                                value={formik.values.service_type}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                            >
                                                <option value="" disabled>-Select a value-</option>
                                                <option value="Custom Clearance">Custom Clearance</option>
                                                <option value="Freight Forwarding">Freight Forwarding</option>
                                                <option value="Both">Both</option>
                                            </select>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="row my-2">
                                    <div className="d-flex align-items-center flex-wrap row-gap-2 gap-2">
                                        <div className="form-check ">
                                            <input type="checkbox"
                                                className="form-check-input "
                                                name="entity_type"
                                                id="shipper"
                                                value="shipper"
                                                onChange={handleCheckboxChange}
                                                checked={formik.values.entity_type.includes("shipper")}
                                            />
                                            <label
                                                className="form-label mb-0"
                                                htmlFor="shipper"

                                            >
                                                Shipper
                                            </label>
                                        </div>

                                        <div className="form-check ">
                                            <input type="checkbox" className="form-check-input " id="consignee"
                                                name="entity_type"
                                                value="consignee"
                                                onChange={handleCheckboxChange}
                                                checked={formik.values.entity_type.includes("consignee")} />
                                            <label
                                                className="form-label mb-0"
                                                name="entity_type"
                                                htmlFor="consignee"
                                            >
                                                Consignee
                                            </label>
                                        </div>
                                        <div className="form-check ">
                                            <input type="checkbox" className="form-check-input " id="services"
                                                name="entity_type"
                                                value="services"
                                                onChange={handleCheckboxChange}
                                                checked={formik.values.entity_type.includes("services")} />
                                            <label
                                                className="form-label mb-0"
                                                htmlFor="services"
                                            >
                                                Services
                                            </label>
                                        </div>
                                        {!disbaleAgent && <div className="form-check"
                                            title={disbaleAgent && "You can not select agent as this customer is already created via an agent."}
                                        >
                                            <input type="checkbox" className="form-check-input " id="agent"
                                                name="entity_type"
                                                value="agent"
                                                onChange={handleCheckboxChange}
                                                checked={formik.values.entity_type.includes("agent")}
                                                disabled={disbaleAgent}

                                            />
                                            <label
                                                className="form-label mb-0"
                                                htmlFor="agent"
                                                disabled={disbaleAgent}
                                            >
                                                Agent
                                            </label>
                                        </div>}
                                        <div className="form-check ">
                                            <input type="checkbox" className="form-check-input " id="carrier"
                                                name="entity_type"
                                                value="carrier"
                                                onChange={handleCheckboxChange}
                                                checked={formik.values.entity_type.includes("carrier")} />
                                            <label
                                                className="form-label mb-0"
                                                htmlFor="carrier"
                                            >
                                                Carrier
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row d-flex justify-content-end">
                                    <div className="col-md-6 d-flex justify-content-end">
                                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Save and Next"}
                                        </button>
                                    </div>
                                </div>
                            </form>



                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrganisationAdd